import { render } from "./SpecialismMultiSelectModel.vue?vue&type=template&id=39a78b08&scoped=true&ts=true"
import script from "./SpecialismMultiSelectModel.vue?vue&type=script&lang=ts"
export * from "./SpecialismMultiSelectModel.vue?vue&type=script&lang=ts"

import "./SpecialismMultiSelectModel.vue?vue&type=style&index=0&id=39a78b08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a78b08"]])

export default __exports__